module.exports = __webpack_public_path__ + "img/product-icon-3.59e0abdd.svg";